import { render, staticRenderFns } from "./add-cause.vue?vue&type=template&id=7b2715ff"
import script from "./add-cause.vue?vue&type=script&lang=js"
export * from "./add-cause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports